import { useCallback, useContext, useEffect, useMemo, useState } from "react"

import { useLocation, useSearchParams } from "react-router-dom"

import { motion } from "framer-motion"

import {

	Alert,

	Box,

	Card,

	CardContent,

	CircularProgress,

} from "@mui/material"



import TopoMenu from "../../../componentes/gerais/TopoMenu"

import MenuLateral from "../../../componentes/gerais/Menu"

import { ContextoGeral } from "../../../contextos/ContextoGeral"

import { configAnim } from "../../../servicos/config/configAnim"

import ServicoAPI from "../../../servicos/ServicoAPI"
import {
	atualizarLocalizacaoProfissionalGestaoVaga,
	obterLocalizacaoProfissionalGestaoVaga,
} from "../../../servicos/gestaoVagaLocalizacao"
import { atualizarGeoERecarregarGestaoVagaHub } from "./gestaoVagaAtualizarGeo.js"
import { mergeEstadoFilaNoDetalhe } from "./gestaoVagaFilaUi.js"

import GestaoVagaMensagem from "./GestaoVagaMensagem"

import GestaoVagaListaCard from "./GestaoVagaListaCard"

import GestaoVagaDetalheSheet from "./GestaoVagaDetalheSheet"


import { GestaoVagaChipIngresso } from "./GestaoVagaOcupacao"

import { resolverIngressoVaga, vagaTemIngressoDisponivel } from "./gestaoVagaIngressoMock.js"

import GestaoVagaCidadeDistancia from "./GestaoVagaCidadeDistancia.jsx"
import GestaoVagaPrioridadeModal from "./GestaoVagaPrioridadeModal.jsx"
import GestaoVagaAbaFila from "./GestaoVagaAbaFila.jsx"
import GestaoVagaConfirmacaoModal from "./GestaoVagaConfirmacaoModal.jsx"
import {
	aplicarPrioridadeLista,
	carregarGestaoVagaHub,
	GV_HUB_ABA_FILA,
	GV_HUB_ABA_MINHAS,
	GV_HUB_ABA_PERTO,
	resolverEntradaHub,
} from "./gestaoVagaHubApi.js"
import {
	aplicarRotuloVagaTexto,
	resolverRotulosGestaoVaga,
} from "./gestaoVagaRotuloUtil.js"
import "./gestaoVaga.css"

export default function GestaoVaga({ entradaInicial }) {

	const { dados, gestaoVagasModulo, recarregarGestaoVagasModulo } = useContext(ContextoGeral)

	const location = useLocation()
	const [searchParams] = useSearchParams()
	const entradaHub = resolverEntradaHub(location, entradaInicial)
	const idVagaDestaque = parseInt(searchParams.get("idVaga"), 10) || 0

	const [menu, setMenu] = useState(false)
	const [confirmacaoModalAberto, setConfirmacaoModalAberto] = useState(false)
	const [confirmacaoVaga, setConfirmacaoVaga] = useState(null)



	const [carregando, setCarregando] = useState(true)

	const [erro, setErro] = useState("")

	const [quantidade, setQuantidade] = useState(0)

	const [vagas, setVagas] = useState([])

	const [vagaUnica, setVagaUnica] = useState(null)



	const [detalheAberto, setDetalheAberto] = useState(false)

	const [detalheCarregando, setDetalheCarregando] = useState(false)

	const [detalheVaga, setDetalheVaga] = useState(null)
	const [detalheDestaqueIngresso, setDetalheDestaqueIngresso] = useState(null)
	const [abaHub, setAbaHub] = useState(GV_HUB_ABA_PERTO)
	const [textosUx, setTextosUx] = useState(null)
	const [vagasPerto, setVagasPerto] = useState([])
	const [vagasMinhas, setVagasMinhas] = useState([])
	const [vagasFila, setVagasFila] = useState([])
	const [filaDiagnostico, setFilaDiagnostico] = useState(null)
	const [prioridadePrincipal, setPrioridadePrincipal] = useState(null)
	const [prioridadeRelogio, setPrioridadeRelogio] = useState(null)
	const [idsPrioridadeHoje, setIdsPrioridadeHoje] = useState(() => new Set())
	const [modalPrioridadeAberto, setModalPrioridadeAberto] = useState(false)
	const [atualizandoGeo, setAtualizandoGeo] = useState(false)



	const [moduloInfo, setModuloInfo] = useState(location.state?.moduloInfo ?? null)
	const [moduloCarregando, setModuloCarregando] = useState(!location.state?.moduloInfo?.ativoModulo)

	const rotulos = useMemo(
		() => resolverRotulosGestaoVaga(moduloInfo?.rotuloMenu),
		[moduloInfo?.rotuloMenu]
	)
	const txt = useCallback(
		(texto) => aplicarRotuloVagaTexto(texto, rotulos),
		[rotulos]
	)

	// Módulo já vem carregado do ContextoGeral (uma requisição por sessão).
	useEffect(() => {
		if (moduloInfo?.ativoModulo) {
			setModuloCarregando(false)
			return
		}
		if (!gestaoVagasModulo?.carregado) return

		if (gestaoVagasModulo.ativo && gestaoVagasModulo.info) {
			setModuloInfo(gestaoVagasModulo.info)
		}
		setModuloCarregando(false)
	}, [gestaoVagasModulo, moduloInfo?.ativoModulo])

	const carregarHub = useCallback(
		async ({ silencioso = false, geo: geoInformado = null, forcarGeo = false } = {}) => {
			if (!dados?.dominio || !dados?.idProf || !dados?.token) {
				setErro(txt("Faça login novamente para acessar Gestão de vaga."))
				if (!silencioso) setCarregando(false)
				return
			}

			if (!silencioso) {
				setCarregando(true)
				setErro("")
			}

			// Ações na Gestão de vaga mudam contagem/fila: atualiza o módulo no contexto
			// para o Menu não exibir badge desatualizado nas próximas páginas.
			recarregarGestaoVagasModulo?.()

			try {
				const geo =
					geoInformado ??
					(forcarGeo
						? await atualizarLocalizacaoProfissionalGestaoVaga()
						: await obterLocalizacaoProfissionalGestaoVaga())
				const res = await carregarGestaoVagaHub(dados, geo, { entrada: entradaHub })

				if (!res.ok) {
					setErro(txt("Não foi possível carregar as vagas."))
					setQuantidade(0)
					setVagas([])
					setVagaUnica(null)
					setVagasPerto([])
					setVagasMinhas([])
					setVagasFila([])
					return
				}

				const hub = res.dados ?? {}
				const listagem = hub.listagem ?? {}
				const erroList = String(listagem.erro ?? "").trim()

				if (geo == null && erroList && (hub.abas?.filaHoje?.quantidade ?? 0) === 0) {
					setErro(txt(erroList || "Ative a localização para ver vagas disponíveis na sua região."))
					setQuantidade(0)
					setVagas([])
					setVagaUnica(null)
					return
				}

				if (erroList && entradaHub !== "fab") {
					setErro(erroList)
				} else if (erroList && entradaHub === "fab") {
					setErro("")
				}

				setTextosUx(hub.textosUx ?? null)
				if (hub.rotuloMenu) {
					setModuloInfo((prev) => ({
						...(prev ?? {}),
						rotuloMenu: String(hub.rotuloMenu).trim() || prev?.rotuloMenu,
					}))
				}
				const abaIni =
					idVagaDestaque > 0
						? GV_HUB_ABA_FILA
						: hub.abaInicial || (entradaHub === "fab" ? GV_HUB_ABA_FILA : GV_HUB_ABA_PERTO)
				if (!silencioso) {
					setAbaHub(abaIni)
				}

				const perto = hub.abas?.perto?.vagas ?? []
				const minhas = hub.abas?.minhas?.vagas ?? []
				const fila = hub.abas?.filaHoje?.vagas ?? []
				setVagasPerto(perto)
				setVagasMinhas(minhas)
				setVagasFila(fila)
				setFilaDiagnostico(hub.fila?.diagnostico ?? null)

				const qtd = Number(listagem.quantidade) || perto.length + minhas.length
				setQuantidade(qtd)
				setVagaUnica(listagem.vagaUnica ?? null)

				let listaVagas = [...perto, ...minhas]
				if (hub.prioridadeHoje) {
					const filaBruta =
						hub.fila?.vagas ??
						fila.map((item) => item?.fila ?? item)
					const pri = aplicarPrioridadeLista(listaVagas, hub.prioridadeHoje, filaBruta)
					listaVagas = pri.vagas
					setIdsPrioridadeHoje(pri.idsPrioridadeHoje)
					setPrioridadePrincipal(pri.prioridadePrincipal)
					setPrioridadeRelogio(pri.prioridadeRelogio)
					setModalPrioridadeAberto(pri.abrirModal)
				} else {
					setPrioridadePrincipal(null)
					setPrioridadeRelogio(null)
					setIdsPrioridadeHoje(new Set())
					setModalPrioridadeAberto(false)
				}

				if (hub.confirmacaoPendente?.pendente) {
					setConfirmacaoVaga({
						idVaga: hub.confirmacaoPendente.idVaga,
						idTitular: hub.confirmacaoPendente.idTitular,
						nome: hub.confirmacaoPendente.nomeVaga || "",
						mensagem: hub.confirmacaoPendente.mensagem || "",
						tipoLembrete: hub.confirmacaoPendente.tipoLembrete || "lembrete_3",
					})
					setConfirmacaoModalAberto(true)
				}

				setVagas(listaVagas)
			} catch {
				setErro(txt("Erro de conexão ao carregar vagas."))
			} finally {
				if (!silencioso) setCarregando(false)
			}
		},
		[dados, entradaHub, idVagaDestaque, txt]
	)

	const atualizarLocalizacaoERecarregarHub = useCallback(async () => {
		setAtualizandoGeo(true)
		try {
			const { ok, geo } = await atualizarGeoERecarregarGestaoVagaHub(carregarHub)
			if (!ok) {
				setErro("Não foi possível obter sua localização. Ative o GPS e tente novamente.")
				return { ok: false, geo: null }
			}
			if (detalheAberto && detalheVaga?.id && geo) {
				const idDet = Number(detalheVaga.id)
				const daLista = [...vagasPerto, ...vagasMinhas, ...vagasFila].find(
					(v) => Number(v?.id) === idDet
				)
				const r = await ServicoAPI.gestaoVagasDetalheApp(dados, idDet, geo)
				if (r?.resultado === true && r?.dados) {
					setDetalheVaga(
						daLista ? mergeEstadoFilaNoDetalhe(r.dados, daLista) : r.dados
					)
				}
			}
			return { ok: true, geo }
		} catch {
			setErro("Erro de conexão ao atualizar localização.")
			return { ok: false, geo: null }
		} finally {
			setAtualizandoGeo(false)
		}
	}, [
		carregarHub,
		dados,
		detalheAberto,
		detalheVaga?.id,
		vagasPerto,
		vagasMinhas,
		vagasFila,
	])

	useEffect(() => {

		if (moduloInfo?.ativoModulo) {

			carregarHub()

		} else {

			setCarregando(false)

		}

	}, [moduloInfo?.ativoModulo, carregarHub])



	const abrirDetalhe = async (idVaga, opcoes = {}) => {
		if (opcoes.destaqueIngressoHoje) {
			setDetalheDestaqueIngresso(opcoes.destaqueIngressoHoje)
		} else if (!opcoes.manterDestaque) {
			setDetalheDestaqueIngresso(null)
		}

		setDetalheAberto(true)

		setDetalheCarregando(true)

		setDetalheVaga(null)

		try {
			const geo = await obterLocalizacaoProfissionalGestaoVaga()
			if (!geo) {
				setDetalheVaga({ erro: txt("Ative a localização para ver os detalhes da vaga.") })
				setDetalheCarregando(false)
				return
			}

			const r = await ServicoAPI.gestaoVagasDetalheApp(dados, idVaga, geo)

			if (r?.resultado === true && r?.dados) {

				setDetalheVaga(r.dados)

			} else {

				setDetalheVaga({ erro: r?.mensagem || "Não foi possível carregar os detalhes." })

			}

		} catch {

			setDetalheVaga({ erro: "Erro de conexão ao carregar detalhes." })

		} finally {

			setDetalheCarregando(false)

		}

	}



	const fecharDetalhe = () => {
		setDetalheAberto(false)
		setDetalheVaga(null)
		setDetalheDestaqueIngresso(null)
	}

	const tituloTopo = rotulos.plural.toUpperCase()

	if (moduloCarregando) {
		return (
			<motion.div
				initial={configAnim.initial}
				animate={configAnim.animate}
				exit={configAnim.exit}
				transition={configAnim.transition}
				className="gv-app gv-app--pagina"
				style={{ height: "100%", width: "100%", maxWidth: "100%" }}
			>
				<TopoMenu voltar="/app/home" titulo={tituloTopo} setShow={setMenu} />
				<div className="gv-app__conteudo flex justify-center py-12">
					<CircularProgress />
				</div>
				<MenuLateral show={menu} setShow={setMenu} />
			</motion.div>
		)
	}

	if (!moduloInfo?.ativoModulo) {
		return (
			<motion.div
				initial={configAnim.initial}
				animate={configAnim.animate}
				exit={configAnim.exit}
				transition={configAnim.transition}
				className="gv-app gv-app--pagina"
				style={{ height: "100%", width: "100%", maxWidth: "100%" }}
			>
				<TopoMenu voltar="/app/home" titulo={tituloTopo} setShow={setMenu} />
				<div className="gv-app__conteudo">
					<Alert severity="warning">
						{txt(
							"Gestão de vagas não está disponível no momento ou não há vagas ativas na sua região."
						)}
					</Alert>
				</div>
				<MenuLateral show={menu} setShow={setMenu} />
			</motion.div>
		)
	}



	const tituloQuantidade =
		quantidade === 1
			? txt("1 vaga disponível")
			: txt(`${quantidade} vagas disponíveis`)

	const ingressoUnica = vagaUnica ? resolverIngressoVaga(vagaUnica) : null

	const hubAbas = textosUx?.hubAbas ?? {}
	const subtituloMenu = txt(textosUx?.menu?.subtitulo || "")
	const qtdComIngressoDisponivel = vagasPerto.filter((v) => vagaTemIngressoDisponivel(v)).length
	const vagasListaHub =
		abaHub === GV_HUB_ABA_MINHAS ? vagasMinhas : abaHub === GV_HUB_ABA_PERTO ? vagasPerto : []
	const temConteudoHub =
		quantidade > 0 || vagasFila.length > 0 || Boolean(vagaUnica)

	const aoAtualizarIngressoVagaUnica = (vagaAtualizada) => {
		if (vagaAtualizada) setVagaUnica(vagaAtualizada)
	}

	const aoAtualizarIngressoDetalhe = (vagaAtualizada) => {
		if (vagaAtualizada) setDetalheVaga(vagaAtualizada)
		carregarHub()
	}

	const aoIngressarPrioridade = (item) => {
		setModalPrioridadeAberto(false)
		if (item?.id) {
			abrirDetalhe(item.id, {
				destaqueIngressoHoje: {
					diaId: String(item.diaId ?? "").trim(),
					data: String(item.dataIngresso ?? item.tempo?.dataIngresso ?? "").trim(),
					horario: String(
						item.horarioJornada || item.tempo?.horaInicioJornada || item.horario || ""
					).trim(),
					tempo: item.tempo ?? null,
				},
			})
		}
	}

	return (

		<motion.div

			initial={configAnim.initial}

			animate={configAnim.animate}

			exit={configAnim.exit}

			transition={configAnim.transition}

			className="gv-app gv-app--pagina"

			style={{ height: "100%", width: "100%", maxWidth: "100%" }}

		>

			<TopoMenu voltar="/app/home" titulo={tituloTopo} setShow={setMenu} />



			<div className="gv-app__conteudo flex-1 min-h-0 min-w-0 w-full max-w-full box-border">

				{carregando ? (

					<Box className="flex justify-center py-8">

						<CircularProgress />

					</Box>

				) : erro ? (

					<Alert severity="error">{erro}</Alert>

				) : !temConteudoHub ? (

					<Alert severity="info">{txt("Nenhuma vaga ativa no momento.")}</Alert>

				) : quantidade === 1 && vagaUnica && abaHub !== GV_HUB_ABA_FILA ? (

					<>

						<Alert severity="success" className="mb-3">

							{tituloQuantidade}

							{ingressoUnica ? (

								<span className="block mt-1 text-sm font-normal">

									Titulares: {ingressoUnica.titularesAtivos} /{" "}

									{ingressoUnica.limiteTitulares}

								</span>

							) : null}

						</Alert>

						{ingressoUnica ? (

							<div className="mb-2">

								<GestaoVagaChipIngresso ingresso={ingressoUnica} />

							</div>

						) : null}

						<GestaoVagaCidadeDistancia
							className="mb-3"
							cidadeEstado={vagaUnica.cidadeEstado || vagaUnica.mensagem?.cidadeEstado}
							distanciaTexto={
								vagaUnica.distanciaTexto || vagaUnica.mensagem?.distanciaTexto
							}
							onAtualizarLocalizacao={atualizarLocalizacaoERecarregarHub}
							atualizandoLocalizacao={atualizandoGeo}
						/>

						<Card className="gv-card" variant="outlined">

							<CardContent>

								<GestaoVagaMensagem

									vaga={vagaUnica}

									dados={dados}

									rotulos={rotulos}

									onIngressoAtualizado={aoAtualizarIngressoVagaUnica}

								/>

							</CardContent>

						</Card>

					</>

				) : (
					<>
						{subtituloMenu ? (
							<p className="text-sm text-slate-600 mb-3 m-0">{subtituloMenu}</p>
						) : null}

						<div className="gv-lista-tabs" role="tablist" aria-label={txt("Seções de vagas")}>
							<button
								type="button"
								role="tab"
								aria-selected={abaHub === GV_HUB_ABA_PERTO}
								className={`gv-lista-tab${abaHub === GV_HUB_ABA_PERTO ? " gv-lista-tab--ativa" : ""}`}
								title={txt(hubAbas.pertoDica || "")}
								onClick={() => setAbaHub(GV_HUB_ABA_PERTO)}
							>
								{txt(hubAbas.perto || "Perto de mim")}
								<span className="gv-lista-tab__badge">{vagasPerto.length}</span>
							</button>
							<button
								type="button"
								role="tab"
								aria-selected={abaHub === GV_HUB_ABA_MINHAS}
								className={`gv-lista-tab${abaHub === GV_HUB_ABA_MINHAS ? " gv-lista-tab--ativa" : ""}`}
								title={txt(hubAbas.minhasDica || "")}
								onClick={() => setAbaHub(GV_HUB_ABA_MINHAS)}
							>
								{txt(hubAbas.minhas || "Minhas vagas")}
								<span className="gv-lista-tab__badge">{vagasMinhas.length}</span>
							</button>
							<button
								type="button"
								role="tab"
								aria-selected={abaHub === GV_HUB_ABA_FILA}
								className={`gv-lista-tab${abaHub === GV_HUB_ABA_FILA ? " gv-lista-tab--ativa" : ""}`}
								title={txt(hubAbas.filaHojeDica || "")}
								onClick={() => setAbaHub(GV_HUB_ABA_FILA)}
							>
								{txt(hubAbas.filaHoje || "Fila de hoje")}
								<span className="gv-lista-tab__badge">{vagasFila.length}</span>
							</button>
						</div>

						{abaHub === GV_HUB_ABA_FILA ? (
							<GestaoVagaAbaFila
								vagasBrutas={vagasFila}
								diagnostico={filaDiagnostico}
								idVagaDestaque={idVagaDestaque}
								onRecarregarHub={carregarHub}
								onAtualizarLocalizacaoHub={atualizarLocalizacaoERecarregarHub}
								atualizandoGeoHub={atualizandoGeo}
								rotulos={rotulos}
							/>
						) : (
							<>
								{abaHub === GV_HUB_ABA_PERTO && qtdComIngressoDisponivel > 0 ? (
									<Alert severity="warning" className="mb-3 mt-3">
										<strong>
											{qtdComIngressoDisponivel === 1
												? txt("1 vaga com ingresso disponível")
												: txt(
														`${qtdComIngressoDisponivel} vagas com ingresso disponível`
													)}
										</strong>
										<span className="block mt-1 text-sm font-normal">
											{txt("Abra os detalhes para se cadastrar nos dias da vaga.")}
										</span>
									</Alert>
								) : null}

								{vagasListaHub.length === 0 ? (
									<Alert severity="info" className="mb-3 mt-3">
										{abaHub === GV_HUB_ABA_MINHAS
											? txt(
													"Você ainda não faz parte de nenhuma vaga. Veja oportunidades em «Perto de mim»."
												)
											: txt("Nenhuma oportunidade na sua região no momento.")}
									</Alert>
								) : (
									<Box className="flex flex-col gap-3 mt-3">
										{vagasListaHub.map((v) => (
											<GestaoVagaListaCard
												key={v.id}
												vaga={v}
												urgenteHoje={idsPrioridadeHoje.has(Number(v?.id))}
												onAbrir={abrirDetalhe}
												onAtualizarLocalizacao={atualizarLocalizacaoERecarregarHub}
												atualizandoLocalizacao={atualizandoGeo}
											/>
										))}
									</Box>
								)}
							</>
						)}
					</>
				)}

			</div>



			<GestaoVagaDetalheSheet

				aberto={detalheAberto}

				carregando={detalheCarregando}

				vaga={detalheVaga}

				destaqueIngressoHoje={detalheDestaqueIngresso}

				rotulos={rotulos}

				onFechar={fecharDetalhe}

				onIngressoAtualizado={aoAtualizarIngressoDetalhe}

				onAtualizarLocalizacao={atualizarLocalizacaoERecarregarHub}

				atualizandoLocalizacao={atualizandoGeo}

			/>

			<GestaoVagaPrioridadeModal
				aberto={modalPrioridadeAberto}
				principal={prioridadePrincipal}
				relogio={prioridadeRelogio}
				rotulos={rotulos}
				onIngressar={aoIngressarPrioridade}
				onVerOutras={() => setModalPrioridadeAberto(false)}
				onFechar={() => setModalPrioridadeAberto(false)}
			/>

			<GestaoVagaConfirmacaoModal
				aberto={confirmacaoModalAberto}
				onFechar={() => {
					setConfirmacaoModalAberto(false)
					setConfirmacaoVaga(null)
				}}
				idVaga={confirmacaoVaga?.idVaga}
				idTitular={confirmacaoVaga?.idTitular}
				nomeVaga={confirmacaoVaga?.nome}
				mensagem={confirmacaoVaga?.mensagem}
				tipoLembrete={confirmacaoVaga?.tipoLembrete}
				onConfirmado={() => carregarHub({ silencioso: true })}
				onRecusado={() => carregarHub({ silencioso: true })}
			/>

			<MenuLateral show={menu} setShow={setMenu} />

		</motion.div>

	)

}

